export enum CheckoutGaPageName {
  Card = 'card',
  DirectDebit = 'direct-debit',
  Landing = 'landing',
  MarketingPreferences = 'marketing-preferences',
  OrderConfirmation = 'order-confirmation',
  PaymentMethod = 'payment-method',
  PersonalDetails = 'personal-details',
}
